
export const meetingTypesTransformer = response => {
  const meetingTypesMap = response.reduce((acc, item) => {
    acc[item?.key] = item
    return acc
  }, {})
  return { data: response, meetingTypesMap }
}
